import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'
import React, { memo } from 'react'

interface Props {
  title?: string
  stepNumber?: number
  stepCount?: number
}

const CustomerFormHeaderComponent = ({ stepNumber, stepCount, title = 'Onboarding' }: Props) => {
  const isResubmit = !stepCount

  return (
    <div
      css={tw`border-0 border-b border-solid border-[#EDEDED] px-4 py-3 flex flex-row items-center justify-between`}
    >
      <Typography variant="h5">{title}</Typography>
      <Typography variant="subtitle1" color={colors.SHADES_GREY_500}>
        {!isResubmit ? `Step ${stepNumber} of ${stepCount}` : ''}
      </Typography>
    </div>
  )
}

export const CustomerFormHeader = memo(CustomerFormHeaderComponent)
